export enum ODMatrixFilteredTypesEnum {
  SENSOR          = 'Sensor',
  DATES           = 'Dates',
  MATRIX          = 'Matrix',
  CAMERA          = 'camera',
  CAMERA_FILTER   = 'camera-filter',
  CAMERA_PEDIOD   = 'camera-period',
}

export interface IFilteredSubscriber {
  type : ODMatrixFilteredTypesEnum;
  values : IMatrix | IDates | IMatrixSensor | any
}

export interface IMatrix {
  direction   : string;
  percentage  : string[]
}

export interface IDates {
  timestamp : string;
}

export interface IMatrixSensor {
  address: string;
  icon: string;
  id: number
  coordinates : any[]
}
